/*
 * CARVERHAUS promises (blocks/ch-assurance.liquid).
 * A tile opens the dialog on its own promise; tabs move between promises.
 * Tabs and panels are built from each tile's <template data-ch-assure-detail>.
 */
if (!customElements.get('ch-assurance')) {
  customElements.define(
    'ch-assurance',
    class ChAssurance extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-ch-assure-dialog]');
        this.addEventListener('click', this.#onClick);
        this.dialog?.addEventListener('click', this.#onBackdrop);
        this.dialog?.addEventListener('keydown', this.#onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
        this.dialog?.removeEventListener('click', this.#onBackdrop);
        this.dialog?.removeEventListener('keydown', this.#onKeydown);
      }

      get #templates() {
        return /** @type {HTMLTemplateElement[]} */ ([...this.querySelectorAll('template[data-ch-assure-detail]')]);
      }

      #open(index) {
        if (!this.dialog) return;
        const tabs = this.dialog.querySelector('[data-ch-assure-tabs]');
        tabs.replaceChildren(
          ...this.#templates.map((template, i) => {
            const tab = document.createElement('button');
            tab.type = 'button';
            tab.className = 'ch-assure__tab';
            tab.setAttribute('role', 'tab');
            tab.dataset.chAssureTab = String(i);
            const icon = template.content.querySelector('[data-ch-assure-tab-icon]');
            if (icon) tab.append(...[...icon.cloneNode(true).childNodes]);
            tab.append(document.createTextNode(template.dataset.title || ''));
            return tab;
          })
        );
        this.#show(index);
        if (!this.dialog.open) this.dialog.showModal();
        tabs.querySelector('[aria-selected="true"]')?.focus();
      }

      #show(index) {
        const templates = this.#templates;
        const template = templates[index];
        if (!template) return;
        const panel = this.dialog.querySelector('[data-ch-assure-panel]');
        const content = /** @type {DocumentFragment} */ (template.content.cloneNode(true));
        content.querySelector('[data-ch-assure-tab-icon]')?.remove();
        panel.replaceChildren(content);
        for (const tab of this.dialog.querySelectorAll('[data-ch-assure-tab]')) {
          const selected = tab.dataset.chAssureTab === String(index);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected) tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }

      #onClick = (event) => {
        const target = /** @type {HTMLElement} */ (event.target);
        const tile = target.closest('[data-ch-assure-tile]');
        if (tile && this.contains(tile)) {
          const tiles = [...this.querySelectorAll('[data-ch-assure-tile]')];
          this.#open(tiles.indexOf(tile));
          return;
        }
        const tab = target.closest('[data-ch-assure-tab]');
        if (tab) {
          this.#show(Number(tab.dataset.chAssureTab));
          return;
        }
        if (target.closest('[data-ch-assure-close]')) this.dialog?.close();
      };

      /* Arrow keys move between tabs */
      #onKeydown = (event) => {
        const tab = /** @type {HTMLElement} */ (document.activeElement)?.closest?.('[data-ch-assure-tab]');
        if (!tab || !['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.dialog.querySelectorAll('[data-ch-assure-tab]')];
        const step = event.key === 'ArrowUp' || event.key === 'ArrowLeft' ? -1 : 1;
        const next = tabs[(tabs.indexOf(tab) + step + tabs.length) % tabs.length];
        this.#show(Number(next.dataset.chAssureTab));
        next.focus();
      };

      #onBackdrop = (event) => {
        if (event.target === this.dialog) this.dialog.close();
      };
    }
  );
}
